export default __webpack_public_path__ + "static/media/24.f3293eee.jpg";